
import { mapState, mapActions } from 'vuex';

export default {
  name: 'AppFilterSectionKeywordFilters',
  props: {
    selectedReviewTagTypes: { type: Array, required: true }
  },
  computed: {
    ...mapState('reviewTagTypes', [
      'reviewTagTypes',
      'isLoadingReviewTagTypes'
    ]),
    ...mapState('reviewSettings', ['reviewSettings']),
    reviewTagTypeOptions() {
      return this.reviewTagTypes.map(({ name, id }) => ({
        name,
        value: id
      }));
    },
    keywordStyleProps() {
      return {
        '--background-color': this.reviewSettings
          .ai_keyword_filter_background_color,
        '--color': this.reviewSettings.ai_keyword_filter_text_color
      };
    }
  },
  created() {
    this.fetchReviewTagTypes();
  },
  methods: {
    ...mapActions('reviewTagTypes', ['fetchReviewTagTypes']),
    reset() {
      if (this.selectedReviewTagTypes.length === 0) return;

      this.$emit('change', []);
    },
    isSelected(option) {
      return this.selectedReviewTagTypes.includes(option.value);
    },
    clickOption(option) {
      if (option.disabled) return;

      const value = option.value;
      let newSelectedReviewTagTypes;
      if (!value) {
        newSelectedReviewTagTypes = [];
      } else if (this.selectedReviewTagTypes.includes(value)) {
        newSelectedReviewTagTypes = this.selectedReviewTagTypes.filter(
          v => v !== value
        );
      } else {
        newSelectedReviewTagTypes = this.selectedReviewTagTypes.concat(value);
      }

      this.$emit('change', newSelectedReviewTagTypes);
    }
  }
};
